import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import * as errorUtils from '../../../modules/utility/global-utils';
import { CacheCountryService } from '../../../services/cacheCountries.service';
import { CountryApiService } from '../../petitioner/services/country.service';

import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LcaService } from 'src/app/services/lca.service';
import { ConfirmationService } from "primeng/api";

@Component({
  selector: 'app-employer-contact-information',
  templateUrl: './employer-contact-information.component.html',
  styleUrls: ['./employer-contact-information.component.scss']
})
export class EmployerContactInformationComponent implements OnInit, OnChanges {

  @Input() employerContactInfoForm: FormGroup;
  @Input() employerContactInformation;
  // @Input() employeeReset;
  contactFormChangesSubscription: any;
  listCountry: any[];
  listStates: any[];
  panelOpenState: boolean = false;
  listContact: any[];
  isDisabledContact: boolean = false;
  companyInfo: any;
  editUserContactInfo: any;
  isDuplicateLCA: boolean = false;
  
  destroy$ = new Subject();
  
  constructor(private apiService: CountryApiService,
              private cacheCountryService: CacheCountryService,
              private fb: FormBuilder,
              private lcaService: LcaService,
              private cdf: ChangeDetectorRef,
              private confirmationService: ConfirmationService,
              protected store: Store<any>) {}

  ngOnChanges(changes: SimpleChanges){
    if(changes.employerContactInformation.currentValue.companyName && sessionStorage.getItem('currentCmpy') == 'true'){
      sessionStorage.removeItem('currentCmpy'); 
      this.isDisabledContact = true;
      this.employerContactInfoForm.reset();
      if(JSON.parse(localStorage.getItem('userEfileInfo'))){
        this.editUserContactInfo = JSON.parse(localStorage.getItem('userEfileInfo')).employerPointOfContactInfo;
        if((changes.employerContactInformation.currentValue.companyName === this.editUserContactInfo.company.companyId) || (this.editUserContactInfo.company.companyId === null && this.editUserContactInfo.employee.id === null)){
          if((this.editUserContactInfo.company.companyId !== null && this.editUserContactInfo.employee.id !== null)){
            this.companyInfo = changes.employerContactInformation.currentValue;
            this.employerContactInfoForm.patchValue({
              addressLine1: this.editUserContactInfo.address.addressLine1,
              addressLine2: this.editUserContactInfo.address.addressLine2,
              id: this.editUserContactInfo.company.companyId,
              companyId: this.editUserContactInfo.company.companyId,
              country: this.editUserContactInfo.address.countryCode,
              state: this.editUserContactInfo.address.stateProvinceCode,
              city: this.editUserContactInfo.address.city,
              postalCode: this.editUserContactInfo.address.postalCode,
              stateProvinceName: this.editUserContactInfo.address.stateProvinceName,
            });
            this.getContactPersonList(this.editUserContactInfo.company.companyId, this.editUserContactInfo.address.countryCode);
          } else {
            this.companyInfo = changes.employerContactInformation.currentValue;
            this.getContactPersonList(changes.employerContactInformation.currentValue.companyName, changes.employerContactInformation.currentValue.country);
          }
          
        } else {
          this.companyInfo = changes.employerContactInformation.currentValue;
          this.employerContactInfoForm.patchValue({
            addressLine1: changes.employerContactInformation.currentValue.addressLine1,
            addressLine2: changes.employerContactInformation.currentValue.addressLine2,
            id: changes.employerContactInformation.currentValue.id,
            companyId: changes.employerContactInformation.currentValue.companyName,
            country: changes.employerContactInformation.currentValue.country,
            state: changes.employerContactInformation.currentValue.state,
            city: changes.employerContactInformation.currentValue.city,
            postalCode: changes.employerContactInformation.currentValue.postalCode,
            stateProvinceName: changes.employerContactInformation.currentValue.stateProvinceName,
          });
          this.getContactPersonList(changes.employerContactInformation.currentValue.companyName, changes.employerContactInformation.currentValue.country);
        }
      } else {
          this.companyInfo = changes.employerContactInformation.currentValue;
          this.employerContactInfoForm.patchValue({
            addressLine1: changes.employerContactInformation.currentValue.addressLine1,
            addressLine2: changes.employerContactInformation.currentValue.addressLine2,
            id: changes.employerContactInformation.currentValue.id,
            companyId: changes.employerContactInformation.currentValue.companyName,
            country: changes.employerContactInformation.currentValue.country,
            state: changes.employerContactInformation.currentValue.state,
            city: changes.employerContactInformation.currentValue.city,
            postalCode: changes.employerContactInformation.currentValue.postalCode,
            stateProvinceName: changes.employerContactInformation.currentValue.stateProvinceName,
          });
          this.getContactPersonList(changes.employerContactInformation.currentValue.companyName, changes.employerContactInformation.currentValue.country);
      }   
    }
  }

  ngOnInit(): void {
    this.cacheCountryService.getCachedCountryList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (data.listCountries.length > 0) {
        this.listCountry = data.listCountries;
      }
    });
    this.isDuplicateLCA = sessionStorage.getItem("isDuplicateLCA") === 'true';
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  getContactPersonList(id, country){
    if(id){
      this.lcaService.getContactPersonList(id).subscribe((res: any) => {
        if(res){
          this.listContact = res;
          if(this.listContact.length==0){
              this.employerContactInfoForm.reset();
              this.listContact = [];
              this.listContact.push({
                id: 'null',
                empName: 'Other'
              });
              this.employerContactInfoForm.patchValue({
                contactPerson: 'null'
              });
              this.isDisabledContact = false;
          }
          if(this.editUserContactInfo){
            if((this.editUserContactInfo.company.companyId === id) || (this.editUserContactInfo.company.companyId === null && this.editUserContactInfo.employee.id === null)){
              this.onChangeContactPerson(this.editUserContactInfo.employee.id);
            } else {
              this.onChangeContactPerson(this.listContact[0].id);
            }
          } else {
            this.onChangeContactPerson(this.listContact[0].id);
          }
          
          if(!this.listContact.find(x => x.id === 'null')){
            this.listContact.push({
              id: 'null',
              empName: 'Other'
            });
          }
          this.onChangeCountry(country);
        }
      });    
    }
    
  }

  onChangeContactPerson(id){
    this.employerContactInfoForm.markAsUntouched();
    if((id !== null) && (id !== 'null')){
      let selectedContact;
      if(this.editUserContactInfo){
        if(this.editUserContactInfo.employee.id === parseInt(id)){
          selectedContact = this.listContact.find(x => x.id === parseInt(id));
        } else {
          selectedContact = this.listContact.find(x => x.id === parseInt(id));
        }
      } else {
        selectedContact = this.listContact.find(x => x.id === parseInt(id));
      }
      if(selectedContact){
        this.employerContactInfoForm.patchValue({
          addressLine1: this.companyInfo.addressLine1,
          addressLine2: this.companyInfo.addressLine2,
          id: this.companyInfo.id,
          companyId: this.companyInfo.companyName,
          country: this.companyInfo.country,
          state: this.companyInfo.state,
          city: this.companyInfo.city,
          postalCode: this.companyInfo.postalCode,
          stateProvinceName: this.companyInfo.stateProvinceName,
          extension: selectedContact.extension,
          contactPerson: selectedContact.id,
          emailId: selectedContact.email,
          firstName: selectedContact.firstName,
          lastName: selectedContact.lastName,
          middleName: selectedContact.middleName,
          phoneNumber: selectedContact.phone,
          jobTitle: selectedContact.designation,
          employeeId: selectedContact.id
        });
        this.isDisabledContact = true;
      }
    } else {
      this.isDisabledContact = false;
      if(JSON.parse(localStorage.getItem('userEfileInfo'))){
        this.editUserContactInfo = JSON.parse(localStorage.getItem('userEfileInfo')).employerPointOfContactInfo;
        if(this.editUserContactInfo.employee.id === null){
          this.employerContactInfoForm.patchValue({
            contactPerson: 'null',
            emailId: this.editUserContactInfo.email.mailId,
            firstName: this.editUserContactInfo.firstName,
            lastName: this.editUserContactInfo.lastName,
            middleName: this.editUserContactInfo.middleName,
            phoneNumber: this.editUserContactInfo.phone.phoneNo,
            jobTitle: this.editUserContactInfo.jobTitle,
            extension: this.editUserContactInfo.phone.phoneCode,
            employeeId: 'null', 
            addressLine1: this.editUserContactInfo.address.addressLine1,
            addressLine2: this.editUserContactInfo.address.addressLine2,
            id: 'null',
            companyId: 'null',
            country: this.editUserContactInfo.address.countryCode,
            state: this.editUserContactInfo.address.stateProvinceCode,
            city: this.editUserContactInfo.address.city,
            postalCode: this.editUserContactInfo.address.postalCode,
            stateProvinceName: this.editUserContactInfo.address.stateProvinceName,
          });
        } else {
          this.employerContactInfoForm.patchValue({
            contactPerson: 'null',
            emailId: null,
            firstName: null,
            lastName: null,
            middleName: null,
            phoneNumber: null,
            jobTitle: null,
            extension: null,
            employeeId: 'null',
            addressLine1: null,
            addressLine2: null,
            id: 'null',
            companyId: 'null',
            country: null,
            state: null,
            city: null,
            postalCode: null,
            stateProvinceName: null,
          });
        }
      } else {
        this.employerContactInfoForm.patchValue({
          contactPerson: null,
          emailId: null,
          firstName: null,
          lastName: null,
          middleName: null,
          phoneNumber: null,
          jobTitle: null,
          extension: null,
          employeeId: null,
          addressLine1: null,
          addressLine2: null,
          id: null,
          companyId: null,
          country: null,
          state: null,
          city: null,
          postalCode: null,
          stateProvinceName: null,
        });
      }
      if(!this.listContact.find(x => x.id === 'null')){
        this.listContact.push({
          id: 'null',
          empName: 'Other'
        });
      }
      this.employerContactInfoForm.patchValue({
        contactPerson: 'null'
      });
      this.cdf.detectChanges();
    }
  }

  onChangeCountry(countryCode: string) {
    this.apiService.getStates(countryCode)
    .pipe(takeUntil(this.destroy$))
    .subscribe((states: []) => {
      this.listStates = states;
      this.listStates.map((item)=>{
        item.state = item.stateProvinceCode;
      })
    });
  }

  clearData() {
    // Clear any previous confirmation
    this.confirmationService.close();

    this.confirmationService.confirm({
      header: "Clear Data",
      icon: "pi pi-exclamation-triangle",
      rejectLabel: "Cancel",
      acceptLabel: "Yes, Clear Data",
      acceptButtonStyleClass: "btn-accept-clear",
      rejectButtonStyleClass: "btn-cancel-clear",
      message: `<div class="mb-4"> This will clear all the data from this section. </div>
                <div class="mb-4"> Are you sure, you want to clear data? </div>`,
      accept: () => {
        this.employerContactInfoForm.reset();
        this.confirmationService.close();
      },
      reject: () => {
         // Clear the confirmation dialog instance after rejection
        this.confirmationService.close();
      },
    });
  }
}
